import { render } from "./ConfirmIronBullRoll.vue?vue&type=template&id=3776c6b1&scoped=true"
import script from "./ConfirmIronBullRoll.vue?vue&type=script&lang=js"
export * from "./ConfirmIronBullRoll.vue?vue&type=script&lang=js"

import "./ConfirmIronBullRoll.vue?vue&type=style&index=0&id=3776c6b1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3776c6b1"]])

export default __exports__